// extracted by mini-css-extract-plugin
module.exports = {"container":"Wave_container__P9pDb"};